export const dictionary = {
  CREATE_BUTTON: {
    ES: "Crear",
    EN: "Create",
  },
  BACK_BUTTON: {
    ES: "Volver",
    EN: "Back",
  },
  UPDATE_BUTTON: {
    ES: "Actualizar",
    EN: "Update",
  },
  CANCEL_BUTTON: {
    ES: "Cancelar",
    EN: "Cancel",
  },
  CONFIRM_BUTTON: {
    ES: "Confirmar",
    EN: "Confirm",
  },
  SAVE_BUTTON: {
    ES: "Guardar",
    EN: "Save",
  },
  DELETE_BUTTON: {
    ES: "Eliminar",
    EN: "Delete",
  },
  DASHBOARD: {
    ES: "Panel",
    EN: "Dashboard",
  },
  PRODUCTS: {
    ES: "Productos",
    EN: "Products",
  },
  CATEGORIES: {
    ES: "Categorías",
    EN: "Categories",
  },
  TABLES: {
    ES: "Mesas",
    EN: "Tables",
  },
  ORDERS: {
    ES: "Pedidos",
    EN: "Orders",
  },
  STOREURL: {
    ES: "Tienda",
    EN: "Store",
  },
  SHARE: {
    ES: "Compartir",
    EN: "Share",
  },
  SETTINGS: {
    ES: "Configuración",
    EN: "Settings",
  },
  ACCOUNT: {
    ES: "Cuenta",
    EN: "Account",
  },
  FIELDS: {
    ES: "Carrito",
    EN: "Cart",
  },
  QRCODE: {
    ES: "Código QR",
    EN: "QR code",
  },
  LOGOUT: {
    ES: "Cerrar sesión",
    EN: "Logout",
  },
  ADD_NEW: {
    ES: "Agregar",
    EN: "Add new",
  },
  ADD_PRODUCT: {
    ES: "Agregar producto",
    EN: "Add product",
  },
  ADD_CATEGORY: {
    ES: "Agregar categoría",
    EN: "Add category",
  },
  SAVE_ORDER: {
    ES: "Guardar cambios",
    EN: "Save order",
  },
  SEARCH: {
    ES: "buscar",
    EN: "search",
  },
  SELECT: {
    ES: "Seleccionar ...",
    EN: "Select ...",
  },
  REMOVE: {
    ES: "Eliminar",
    EN: "Remove",
  },
  WARNING_ACCOUNT: {
    ES: "Bienvenido a Simple! Debes completar los datos de tu cuenta para utilizar tu tienda.",
    EN: "Welcome to Simple! You must complete your account details to use your store.",
  },
  CONFIRM_MODAL_TITLE: {
    ES: "¿Estás seguro?",
    EN: "Are you sure?",
  },
  NOT_DELETABLE: {
    ES: "Este campo no puede ser eliminado.",
    EN: "This field cannot be removed.",
  },
  REQUIRED: {
    ES: "Campo requerido.",
    EN: "Required.",
  },
  YOUR_STORE: {
    ES: "Visita tu tienda",
    EN: "Visit your store",
  },
} as const;
